(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7445],{

/***/ 21856:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[vanity]",
      function () {
        return __webpack_require__(57934);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ VanityProfile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88767);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _constants_tabs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28141);
/* harmony import */ var _firebase_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32012);
/* harmony import */ var _redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18129);
/* harmony import */ var _redux_createTabSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89515);
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43369);
/* harmony import */ var _public_profile_DesktopView__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55081);
/* harmony import */ var _public_profile_MobileView__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88437);
















var VanityProfile = function(param) {
    var vanity = param.vanity;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var isMdSize = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("(min-width:900px)");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        "vanityProfile",
        vanity
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var uid, ref, userData, imageData, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!vanity || typeof vanity !== "string") {
                        return [
                            2,
                            {
                                imageData: null,
                                userData: null
                            }
                        ];
                    }
                    if (vanity === "browse") {
                        return [
                            2,
                            {
                                imageData: null,
                                userData: null
                            }
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0,_firebase_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchUidFromVanity */ .BR)(vanity)
                    ];
                case 2:
                    uid = _state.sent();
                    if (!uid) {
                        // Redirect to 404 page or home page if vanity URL not found
                        router.replace("/404");
                        return [
                            2,
                            {
                                imageData: null,
                                userData: null
                            }
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchUserData */ .FQ)(uid),
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_6__/* .fetchImagesFromUid */ .s0)(uid)
                        ])
                    ];
                case 3:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), userData = ref[0], imageData = ref[1];
                    return [
                        2,
                        {
                            imageData: imageData || null,
                            userData: userData || null
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Error fetching vanity profile:", error);
                    router.replace("/404");
                    return [
                        2,
                        {
                            imageData: null,
                            userData: null
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), {
        enabled: !!vanity && typeof vanity === "string",
        retry: 1,
        retryDelay: 1000
    }), dataIsLoading = ref.isLoading, dataError = ref.error, data = ref.data;
    var userData = data === null || data === void 0 ? void 0 : data.userData;
    var imageData = data === null || data === void 0 ? void 0 : data.imageData;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (userData) {
            dispatch((0,_redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_7__/* .setSelectedSidebarUser */ .My)(userData));
            dispatch((0,_redux_createTabSlice__WEBPACK_IMPORTED_MODULE_8__/* .setTab */ .IE)(_constants_tabs__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Search */ .Z.Search));
        }
        return function() {
            dispatch((0,_redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_7__/* .setSelectedSidebarUser */ .My)(null));
        };
    }, [
        userData,
        dispatch
    ]);
    // Show loader while data is loading
    if (dataIsLoading || !vanity) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
    }
    // Show error state
    if (dataError) {
        console.error("Error loading profile:", dataError);
        router.replace("/404");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
    }
    // Show loader if no user data
    if (!userData || !imageData) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
    }
    var userCreatedAt = (userData === null || userData === void 0 ? void 0 : userData.createdAt) && new Date(userData.createdAt);
    return isMdSize ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_profile_DesktopView__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        userData: userData,
        imageData: imageData
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_profile_MobileView__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        userData: userData,
        imageData: imageData
    });
};


/***/ }),

/***/ 57934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_innerLayout_InnerLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66570);
/* harmony import */ var _components_VanityProfile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80334);





var VanityUrlPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var vanity = router.query.vanity;
    var hasLoggedInitial = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var LOG_PREFIX = "[VanityPage]";
    var reservedRoutes = [
        "admin",
        "api",
        "auth",
        "browse",
        "chef",
        "creating-contract",
        "finance",
        "gig",
        "gigs",
        "message",
        "profile",
        "profile-public",
        "user",
        "_app",
        "_document",
        "index",
        "404",
        "500", 
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!router.isReady) {
            return;
        }
        if (!hasLoggedInitial.current) {
            hasLoggedInitial.current = true;
            console.info(LOG_PREFIX, "mount", {
                path: router.asPath,
                vanity: vanity
            });
        }
        if (vanity && typeof vanity === "string") {
            if (reservedRoutes.includes(vanity)) {
                console.info(LOG_PREFIX, "reservedRouteRedirect", {
                    path: router.asPath,
                    vanity: vanity,
                    target: "/".concat(vanity)
                });
                router.replace("/".concat(vanity));
                return;
            }
            console.info(LOG_PREFIX, "vanityRender", {
                path: router.asPath,
                vanity: vanity
            });
        }
    }, [
        vanity,
        router.asPath,
        router.isReady,
        router.replace
    ]);
    if (!router.isReady) {
        return null;
    }
    if (vanity && typeof vanity === "string" && reservedRoutes.includes(vanity)) {
        console.info(LOG_PREFIX, "reservedRouteNull", {
            path: router.asPath,
            vanity: vanity
        });
        return null;
    }
    // For non-reserved routes, render the profile page
    if (vanity && typeof vanity === "string") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VanityProfile__WEBPACK_IMPORTED_MODULE_4__/* .VanityProfile */ .Y, {
            vanity: vanity
        });
    }
    // Handle cases where vanity is not a string (e.g., /?vanity=foo) or other errors
    return null;
};
// Add the getLayout function to ensure proper layout is applied
VanityUrlPage.getLayout = function getLayout(component) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_innerLayout_InnerLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: component
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VanityUrlPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,1255,8809,9066,89,9912,1440,6570,6746,5839,3090,9774,2888,179], function() { return __webpack_exec__(21856); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);